module.exports = __webpack_public_path__ + "media/images/modules/publisher/tabs/video_letter-a7d3e5927dff3c76ae4720e073ce8c92.png";